import { fetch } from '../utils/helpers';
import { env } from '../config'

const API_URL = () => {return `${env.REACT_APP_BASS_RAVMILIM_API_URL()}/User`};

export const userApi =(() => {
    const GetUserData = (jwtToken) => {
        return fetch(`${API_URL()}/GetUserData`, {
            method: 'GET',
        }, jwtToken);
    };

    const GetOrgData = (orgCode) => {
        return fetch(`${API_URL()}/GetOrgData?orgCode=${orgCode}`, {
            method: 'GET',
        });
    };

    const UpdateUserData = (userData, jwtToken) => {
        return fetch(`${API_URL()}/UpdateUserData`, {
            method: 'POST',
            body: JSON.stringify(userData || {}),
        }, jwtToken);
    }

    // Legacy user migration helpers
    const CheckUserInOldDB = (email, password) => {
        return fetch(`${API_URL()}/CheckUserInOldDB`, {
            method: 'POST',
            body: JSON.stringify({ "Email": email, "Password": password }),
        });
    };

    // Backend expects empty body; token must be provided for Authorization
    // Some parts of the app may pass (email, oldPassword, token); be permissive
    const MigrateUserFromOldDB = (arg1, arg2, arg3) => {
        let jwtToken = arg1;
        // Backward-compat: if called as (email, password, token)
        if (typeof arg3 === 'string' && arg3) {
            jwtToken = arg3;
        }
        return fetch(`${API_URL()}/MigrateUserFromOldDB`, {
            method: 'POST',
            body: JSON.stringify({}),
        }, jwtToken);
    };

    // signupOnly: new-user registration — the server must resolve the phone from Cognito
    // only, never from the app/legacy DB by email (that would be someone else's number).
    const GetSmsOption = (email, signupOnly = false) => {
        return fetch(`${API_URL()}/GetSmsOption?email=${encodeURIComponent(email)}&signupOnly=${signupOnly}`, { method: 'GET' });
    };

    const GetVoiceOption = (email, signupOnly = false) => {
        return fetch(`${API_URL()}/GetVoiceOption?email=${encodeURIComponent(email)}&signupOnly=${signupOnly}`, { method: 'GET' });
    };

    const SendSmsOtp = (email, signupOnly = false) => {
        return fetch(`${API_URL()}/SendSmsOtp`, {
            method: 'POST',
            body: JSON.stringify({ Email: email, SignupOnly: signupOnly }),
        });
    };

    const SendVoiceOtp = (email, signupOnly = false) => {
        return fetch(`${API_URL()}/SendVoiceOtp`, {
            method: 'POST',
            body: JSON.stringify({ Email: email, SignupOnly: signupOnly }),
        });
    };

    const VerifySmsOtpAndResetPassword = (email, code, newPassword) => {
        return fetch(`${API_URL()}/VerifySmsOtpAndResetPassword`, {
            method: 'POST',
            body: JSON.stringify({ Email: email, Code: code, NewPassword: newPassword }),
        });
    };

    const VerifySmsOtpAndConfirmAccount = (email, code) => {
        return fetch(`${API_URL()}/VerifySmsOtpAndConfirmAccount`, {
            method: 'POST',
            body: JSON.stringify({ Email: email, Code: code }),
        });
    };

    return {
        GetUserData,
        GetOrgData,
        UpdateUserData,
        CheckUserInOldDB,
        MigrateUserFromOldDB,
        GetSmsOption,
        GetVoiceOption,
        SendSmsOtp,
        SendVoiceOtp,
        VerifySmsOtpAndResetPassword,
        VerifySmsOtpAndConfirmAccount,
    };
})();